import { render } from "./PasswordResetChange.vue?vue&type=template&id=7afa7bf4&scoped=true&ts=true"
import script from "./PasswordResetChange.vue?vue&type=script&lang=ts"
export * from "./PasswordResetChange.vue?vue&type=script&lang=ts"

import "./PasswordResetChange.vue?vue&type=style&index=0&id=7afa7bf4&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afa7bf4"]])

export default __exports__